import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import { jeCreator } from "parog-web/helpers/je-creator";
import type AlertTriggeredJournalEvent from "parog-web/models/alert-triggered-journal-event";
import JournalEvent from "parog-web/models/journal-event";
import type Patient from "parog-web/models/patient";
import tWithDefault from "parog-web/utils/t-with-default";

//---- Automatically generated, don't update this part ----

export default class AlertProcessedJournalEvent extends JournalEvent {
  static override type = "alert-processed-journal-event";

  @attr("string") declare actionTaken: string;

  @belongsTo("alert-triggered-journal-event", {
    async: false,
    inverse: "alertProcessedJournalEvent"
  })
  declare alertTriggeredJournalEvent: AlertTriggeredJournalEvent;

  static override validations(intl: IntlService) {
    return {
      actionTaken: validatePresence({
        presence: true,
        description: intl.t(
          "validations.alert-processed-journal-event.action-taken"
        )
      }),
      alertTriggeredJournalEvent: validatePresence({
        presence: true,
        description: intl.t(
          "validations.alert-processed-journal-event.alert-triggered-journal-event"
        )
      }),
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.alert-processed-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----

  @belongsTo("patient", {
    async: false,
    inverse: "alertProcessedJournalEvents"
  })
  declare patient: Patient;

  override get description(): string {
    return this.alertTriggeredJournalEvent.description;
  }

  override get summary() {
    const creator = jeCreator([this]);

    // this is for automaticaly treated forgetting constant alerts
    const isAuto =
      creator === "le programme" && this.actionTaken === "irrelevant";

    const actionLabel = isAuto
      ? "Traitée automatiquement"
      : this.intl.t(`alert.processing.type.${this.actionTaken}`);

    const details = `Le ${dayjs(this.occurredAt).format(
      "DD/MM/YYYY à HH:mm"
    )} par ${creator} – ${actionLabel}`;

    return Object.assign(super.summary, {
      date: this.alertTriggeredJournalEvent.occurredAt.toISOString(),
      details
    });
  }
}
// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "alert-processed-journal-event": AlertProcessedJournalEvent;
  }
}
